import { Component } from '@angular/core';
interface TechItem {
  name: string;
  icon: string;
}

interface TechGroup {
  title: string;
  items: TechItem[];
}
@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss'],
})
export class ServicesComponent {
  techGroups: TechGroup[] = [
    {
      title: 'Backend',
      items: [
        { name: '.NET', icon: 'assets/img/NET_Core.svg' },
        { name: 'PostgreSQL', icon: 'assets/img/Postgresql_elephant (1).svg' },
        { name: 'Node.js', icon: 'assets/img/node.svg' },
        { name: 'MongoDB', icon: 'assets/img/mongodb.svg' },
      ],
    },
    {
      title: 'Frontend',
      items: [
        { name: 'Angular', icon: 'assets/img/angular-icon.svg' },
        { name: 'TypeScript', icon: 'assets/img/typescript.svg' },
        { name: 'JavaScript', icon: 'assets/img/javascript.svg' },
        { name: 'React', icon: 'assets/img/react.svg' },
      ],
    },
    {
      title: 'DevOps / Infrastructure',
      items: [
        { name: 'Docker', icon: 'assets/img/docker.svg' },
        { name: 'Azure', icon: 'assets/img/azure.svg' },
        { name: 'AWS', icon: 'assets/img/aws.svg' },
        { name: 'GitHub Actions', icon: 'assets/img/GitHubActions.png' },
      ],
    },
  ];

  copy(group: TechGroup): void {
    const text = `${group.title}: ${group.items.map((i) => i.name).join(', ')}`;
    navigator.clipboard.writeText(text);
  }
}
